import { useContext, useMemo } from "react";

import AddPageSubMenu from "src/components/layouts/AddPageSubMenu";
import DepartmentIdentityContext from "src/contexts/data/DepartmentIdentityContext";
import InstitutionIdentityContext from "src/contexts/data/InstitutionIdentityContext";
import { createDepartmentSubMenu } from "src/routing/navigation";

/**
 * Registers the department submenu through the shared layout adapter.
 *
 * Postconditions: A rendered registration requests layout updates after render and removes its
 * submenu code on cleanup. Navigation factories retain responsibility for link metadata.
 * Missing required identities yield no registration. Identity references control recomputation.
 */
const DepartmentSubMenu: React.FC = () => {
    const { data: institutionIdentity } = useContext(InstitutionIdentityContext);
    const { data: departmentIdentity } = useContext(DepartmentIdentityContext);

    const subMenu = useMemo(
        () => {
            if (!institutionIdentity || !departmentIdentity) {
                return null;
            }

            return createDepartmentSubMenu(institutionIdentity, departmentIdentity);
        },
        [departmentIdentity, institutionIdentity]
    );

    if (!subMenu) {
        return null;
    }

    return <AddPageSubMenu subMenu={subMenu} />;
};

export default DepartmentSubMenu;
